import { AccountCircle, Star } from '@mui/icons-material';

const Reviews = [
    {
        id: 1,
        name: "Tushar Kothkar",
        review: "Prompt and highly efficient work. They made my custom site exactly how I wanted it. Thank you so much Bluecoder.",
        image: <AccountCircle className="userIcon" />,
        rating: <><Star /><Star /><Star /><Star /><Star /></>
    },
    {
        id: 2,
        name: "Nagraj Patil",
        review: "Great individuals and easy to work with. Really supportive even after the work is done. Im more than satisfied.",
        image: <AccountCircle className="userIcon" />,
        rating: <><Star /><Star /><Star /><Star /><Star /></>
    },
    {
        id: 3,
        name: "Shubham Gujar",
        review: "Best website designing company in Nagpur, I am really satisfied & they've done more than expected. Special thanks to Blucoder.",
        image: <AccountCircle className="userIcon" />,
        rating: <><Star /><Star /><Star /><Star /><Star /></>
    },
];

export default Reviews